"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = fetchInvoice;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _humps = require("humps");

var _utils = require("@dom/utils");

function fetchInvoice(_x) {
  return _fetchInvoice.apply(this, arguments);
}

function _fetchInvoice() {
  _fetchInvoice = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(invoiceId) {
    var _ref, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _utils.api.get("payments/invoices/".concat(invoiceId));

          case 3:
            _ref = _context.sent;
            data = _ref.data;
            return _context.abrupt("return", (0, _humps.camelizeKeys)(data));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            throw _context.t0;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _fetchInvoice.apply(this, arguments);
}